import { getApiInstance } from "../../../api";
import ApiClient from "../../../apiClient";
import mutationWrapper from "../../mutationWrapper";
import getQueryClient from "../../queryClient";
import { allKontakReferensiKey } from "./useFetchKontakReferensi";
import { EditKontakReferensi } from "../../../../models/KontakReferensi";

export async function editKontakReferensi(data: EditKontakReferensi) {
    const res = await ApiClient.put(`/EditReferenceContact`, data);
    return res.data;
}

export const useEditKontakReferensi = mutationWrapper(editKontakReferensi, {
    onSuccess: () => {
        getQueryClient().invalidateQueries(allKontakReferensiKey);
    },
});
